var $ = require('jquery');
var NotificationBase = require('../NotificationBase');

/* globals jimdoData, diy */
(function () {
    'use strict';
    var ExternalWebsiteImportBlueNotification = NotificationBase.extend({
        /**
         * Default sticky
         */
        stickyDefault: 0,
        /**
         * Default severity
         */
        severityDefault: 1,
        /**
         *
         */
        flashNotification: true,
        /**
         * Default category for GuidanceNotification
         */
        categoryDefault: 1,
        /**
         *
         * @param resource
         */
        initialize: function(resource) {
            this._super(resource);
            this.bubbleOptions.autoHide = false;
            this.bubbleOptions.hideDelay = 0;
            this.bubbleOptions.closable = false;

            this.bubbleOptions.dismissCallback = null;
            this.bubbleOptions.clickCallback = null;
        },
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star-white',
        getCssClassSuffix: function() {
            return 'ext-website-import-blue';
        },
        getContent: function () {
            var content = '<div></div>',
                payload = this.getPayload();
            if (this.content) {
                content = this.content
            } else {
                if (payload && payload.content) {
                    content = payload.content;
                }
            }

            return $(content);
        },
        setIconCls: function(iconCl) {
            this.iconCls = iconCl;
        },

        getName: function() {
            return 'ExternalWebsiteImportBlueNotification';
        },
        globalAction: null
    });
    module.exports = ExternalWebsiteImportBlueNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/ExternalWebsiteImportBlueNotification.js
 ** module id = 661
 ** module chunks = 0
 **/